module.exports = __webpack_public_path__ + "img/Blast_Off_Club_House29.5279dd8a.jpg";